
import { defineComponent } from 'vue'
import { request } from '@/store/case'

export default defineComponent({

  setup() {
    return {
      request
    }
  }
})
